import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TeamShortModal } from "app/components";
import { DrawingEuroSuperCupDto, DrawingFixtureDto } from "app/models";
import { DrawingsService, NotificationService } from "app/services";

@Component({
    selector: 'drawind-euro-super-cups',
    templateUrl: 'euro-super-cup.page.html',
    styleUrls: ['euro-super-cup.page.scss'],
})
export class DrawingEuroSuperCupPage implements OnInit {
    
    pair: DrawingEuroSuperCupDto;

    formGroup : FormGroup;

    isProcessing: boolean;

    drawing: DrawingFixtureDto;

    constructor(private drawingService: DrawingsService,
        private modalService: NgbModal,
        private notificationService: NotificationService) {

    }
    
    ngOnInit(): void {
        this.buildForm();
        this.loadData();
    }

    onSubmit() {
        if (!this.formGroup.controls.mdFormControl.value) {
            this.notificationService.showError('Не выбран ИД.');
            return;
        }

        if (!this.pair.lchWinner || !this.pair.leWinner || this.pair.lchWinner.id === this.pair.leWinner.id) {
            this.notificationService.showError('Некорректные команды.');
            return;
        }

        this.isProcessing = true;

        this.drawingService.saveEuroSuperCupFixture(this.pair.lchWinner, this.pair.leWinner, this.formGroup.controls.mdFormControl.value)
            .subscribe(result => {
                this.isProcessing = false;
                this.drawing = result;
            }, error => {
                this.notificationService.showError('Ошибка сохранения.');
                this.isProcessing = false;
            })
    }

    onChangeTeam(isLCH: boolean) {
        const modalRef = this.modalService.open(TeamShortModal);

        modalRef.componentInstance.team = isLCH ? this.pair.lchWinner : this.pair.leWinner;

        modalRef.result.then((result) => {
            if (result) {
                if (isLCH) {
                    this.pair.lchWinner = result;
                } else {
                    this.pair.leWinner = result;
                }
            }
        }, (reason) => { });
    }
    
    private loadData() {
        this.drawingService.getEuroSuperCupPair()
            .subscribe(result => {
                this.pair = result;
            })
    }

    private buildForm() {
        this.formGroup = new FormGroup({
            mdFormControl: new FormControl(),
        });
    }
}